

var _learnq = window._learnq || [];
var iframe = document.getElementById('video-frame');
if(iframe) {
  var player = $f(iframe);

  var playButton = document.getElementById("show-vimeo-play");
  playButton.addEventListener("click", function() { 
    if(iframe.dataset.src){
      iframe.src = iframe.dataset.src;   
    }
    player.api("play");
    playButton.parentNode.removeChild(playButton);
  });
}

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    offset: 10000
  });
});

$.fn.randomize = function(selector){
  (selector ? this.find(selector) : this).parent().each(function(){
    $(this).children(selector).sort(function(){
      return Math.random() - 0.5;
    }).detach().appendTo(this);
  });
  return this;
};

$(document).ready(function(){ 
  $(".site-nav__link--has-dropdown").on('click', function(e){
    e.preventDefault();
  }) ; 
  
  $('.fancybox').fancybox();
 
  $('.storefinder').on('click', function(){
    ga('send', 'event', 'On Screen Interaction', 'Modal', 'Store Locator'); 
  });
  
  /*============================================================================
      #HEADER
  ==============================================================================*/   
  $(".site-nav__dropdown-link--mega").mouseenter(function() {
    var windowWidth = $(window).width();
    if(windowWidth > 1000) {
      var menuTitle = $(this).attr('href'),
          menuPromoBox = $('.megamenu__promo[data-hover="' + menuTitle + '"]');
      $('.megamenu__promo').clearQueue().hide();
      menuPromoBox.clearQueue().delay(500).show(0);
    }
  });
  
  $(".megamenu").mouseleave(function() {
    $('.megamenu__promo').clearQueue().hide();
  });
  
  /*============================================================================
      #HOME
  ==============================================================================*/ 
  var flktyRecipesObj = document.querySelector('.recipe-blog-scroller .grid');
  if(flktyRecipesObj){
    doLogoScroll = flktyRecipesObj.dataset.scroll;
    if(doLogoScroll == 'true') {
      var flktyRecipes = new Flickity(flktyRecipesObj, {
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        autoPlay: false,
        dragThreshold: 10,
        adaptiveHeight: false,
        pageDots: false
      });
      flktyRecipes.on('dragStart', () => flktyRecipes.slider.style.pointerEvents = 'none');
      flktyRecipes.on('dragEnd', () => flktyRecipes.slider.style.pointerEvents = 'auto');
      $(window).resize(function(){
        flktyRecipes.resize();
      });
    }
  }
    
  var flktyProducts = new Flickity(document.querySelector('.featured-products-scroller .grid'), {
    cellAlign: 'center',
    contain: true,
    autoPlay: false,
    dragThreshold: 10,
    pageDots: false,
    adaptiveHeight: false,
    lazyLoad: true,
    groupCells: true
  });

  flktyProducts.on('dragStart', () => flktyProducts.slider.style.pointerEvents = 'none');
  flktyProducts.on('dragEnd', () => flktyProducts.slider.style.pointerEvents = 'auto');
 
  let tickerSpeed = 1;
  const updateLogos = () => {
    if (flktyLogos.slides) {
      flktyLogos.x = (flktyLogos.x - tickerSpeed) % flktyLogos.slideableWidth;
      flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
      flktyLogos.updateSelectedSlide();
      flktyLogos.settle(flktyLogos.x);
    }
    window.requestAnimationFrame(updateLogos);
  };
  
  flktyLogos = new Flickity(document.querySelector('.logo-list-scroller .grid'), {
    autoPlay: false,
    cellAlign: 'center',
    contain: true,    
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    dragThreshold: 10
  });
  updateLogos();

   var flktyQuotes = new Flickity(document.querySelector('.quote-slider .grid'), {
    cellAlign: 'center',
    contain: true,
    autoPlay: 7000,
    dragThreshold: 20,
    pageDots: false,
    adaptiveHeight: false,
    lazyLoad: true,
    groupCells: true
  });
  
  $(window).resize(function(){
    flktyProducts.resize();
    flktyLogos.resize();
    flktyQuotes.resize();
  });
  
  window.onload = function(){
    var randomize = $('.randomize');
    if(randomize.length) {
      randomize.each(function(){
        $(this).randomize('.grid__item, .logo-bar__item');
      });
    }
  };
  if($('.scrolling--div').length){
    $('.scrolling--div').marquee({
      speed: 30,
      gap: 26,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  
  $('#shopify-section-article-template h3.collapsible').click(function(){
    $(this).parent().find('.collapsible-section').slideToggle('fast');
    $(this).toggleClass('collapsed');
  });

  
  
  /*============================================================================
      #POPUP
  ==============================================================================*/  
  var giveawayWait = setInterval(function() {  
    if($('body').find('.new-years-2025-signup form.klaviyo-form').length > 0) {            
      $('body').find('.new-years-2025-signup form.klaviyo-form > div > div:nth-child(3) button').on('click', function(){
        $("#trigger-success").trigger('click');
      });  
      clearInterval(giveawayWait);
    }
  }, 100); 
  
  var popupWait = setInterval(function() {
    if($('body').find('#NewsletterPopup-newsletter-popup-klaviyo .klaviyo-form').length > 0) {      
      $('body').find('#NewsletterPopup-newsletter-popup-klaviyo .klaviyo-form > div > div:nth-child(3) button').on('click', function(){
        $('body').find('#NewsletterPopup-newsletter-popup-klaviyo input[type=submit]').trigger('click');
      });  
      $('body').find('#NewsletterPopup-newsletter-popup-klaviyo .klaviyo-form > div > div:nth-child(4) button').on('click', function(){
        $('body').find('#NewsletterPopup-newsletter-popup-klaviyo .js-modal-close').trigger('click');
      });      
      clearInterval(popupWait);
    }
  }, 100); 
  
  var popCloseWait = setInterval(function() {
    if($('body').find('#NewsletterPopup-newsletter-popup-klaviyo .klaviyo-form > div > div:nth-child(2) > div > button').length > 0) {
      $('body').find('#NewsletterPopup-newsletter-popup-klaviyo .klaviyo-form > div > div:nth-child(2) > div > button').on('click', function(){
        $('body').find('#NewsletterPopup-newsletter-popup-klaviyo .js-modal-close').trigger('click');
      });      
      clearInterval(popCloseWait);
    }
  }, 100);
      
  
  /*============================================================================
      #INGREDIENTS PAGE
  ==============================================================================*/ 
  $('.tooltip').click(function(){
    $('.tooltip-content').fadeOut();
    var thisContent = $(this).find('.tooltip-content');
    if(thisContent.is(':hidden')) {
      thisContent.fadeIn();
    }
  });
  
  $('.ingredients-image img').click(function(){
    $('.tooltip-content').fadeOut();
  });
  
  
  
  /*============================================================================
      #CAREERS PAGE
  ==============================================================================*/
  
  
    if($('#careers').length) {
    /*
    var bookID = "1AUVQ-C9OH6PmTBfNEV7jYNXz_cvl3fBwCN1yRWgZMLA",  
        sheetID = "1333511202",
        qry = encodeURIComponent("SELECT A, B, C WHERE D = TRUE ORDER BY A ASC"),
        url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID,        
        template = $('.career-template').html();
    
    template = template.replace('not-ready','ready');
    
    $.ajax({
      type: "GET",
      url: url,
      datatype: "json",
      success: function(data){
        data = Papa.parse(data,{header: true});
        data = data.data;

        if(data.length > 0 ) {
          for (let i=0; i< data.length; i++) {
            final_template = template.replace('careerID','career'+i);
            $('body').find('#careers').append(final_template);
          }
          $(data).each(function(index){
            var title = this.Title,
                shortDescription = this.ShortDescription;
                $('body').find('#career'+index+' .title').html(title)
                $('body').find('#career'+index+ ' .shortd').html(shortDescription);        
            
            $.ajax({
              type: "GET",
              url: this.GoogleDocURL,
              datatype: "html",
              success: function(nesteddata){
                nesteddata = nesteddata.split('<script>');
                nesteddata = nesteddata[0];
                nesteddata = nesteddata.split('</style>');
                nesteddata = nesteddata[2].split('<div id="footer">');
                nesteddata = nesteddata[0];
        
				$('body').find('#career'+index+' .longd').html(nesteddata);
                $('body').find('#career'+index+' .longd p, #career'+index+' .longd span, #career'+index+' .longd ul, #career'+index+' .longd li').removeAttr('class');
                $('body').find('#career'+index+' .longd span').each(function(){
                  if($(this).html().indexOf('**') >= 0) {
                    $(this).css('font-weight','bold').html($(this).html().replace('**',''));
                  }
                });
              }
            });
          });
        } else {
          $('#careers .no-careers').show();
        }
      }
    }); 
    */
    $('body').on('click', '.details', function(e){
      e.preventDefault();
      if($(this).html() == 'View Details'){
        $(this).html('Hide Details');
      }
      if($(this).html() == 'Hide Details'){
        $(this).html('View Details');
      }      
      $(this).parent().find('.longd').slideToggle();
    });
            
    $('body').on('click', '.apply', function(e){
      e.preventDefault();
      $('body').find('.application').slideToggle();
    });
  }
   
  
/*============================================================================
      #STORE LOCATOR
  ==============================================================================*/  
  
  
  if($('.store-list').length) {
    var bookID = "1AUVQ-C9OH6PmTBfNEV7jYNXz_cvl3fBwCN1yRWgZMLA",  
        sheetID = "26822831",
        qry = encodeURIComponent("SELECT B, C, D WHERE A = TRUE"),
        url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID;    

    $.ajax({
      type: "GET",
      url: url,
      datatype: "json",
      success: function(data){    
        // Load the returned locations into the map.
        data = Papa.parse(data,{header: true});  
        data = data.data;
        var html = '';
        $(data).each(function(){
          //html += '<div class="grid__item one-sixth text-center"><a href="' + this.Website + '" target="_new">';
          //html += '<img src="' + this.Logo + '" title="' + this.Name + '"></a></div>';
		  html += '<div class="grid__item one-sixth text-center"><img src="' + this.Logo + '" title="' + this.Name + '"></div>';
        });
        $('.store-list').append(html);
      }
    });
  }
  
  

  /*============================================================================
      #CART
  ==============================================================================*/  

  if($('#TriggerCartMessagePopup')) {
    $('#TriggerCartMessagePopup').trigger('click');
  }
  
  $('#CartNote').on('change',function(){
    if($(this).val().includes('Gift Message:') != true) {   
      $(this).val('Gift Message: ' +  $(this).val());
    }
  });
                 
  if($('.template-cart .cart__box')) {
    $(document).on('click', '#remove-box', function(e){
      e.preventDefault();
      updateAllBoxes($(this).attr('data-box-id'),$(this).attr('data-box-variants'),$(this).attr('data-title'));
    });   
    $(document).on('click', '#remove', function(e){
      e.preventDefault();
      removeCartItem($(this));
    });      
  }

  function updateAllBoxes(boxID,variants,productTitle) {
    var list = variants.split(','),
        removeList = '';
    
    for(var i=0; i<list.length; i++) {
      if(removeList.length > 0){ removeList += '&' }
      removeList += 'updates[' + list[i] + ']=0';
    }
    if(removeList != '') {
      addToQueue('update',removeList,null,null);
    }
    Shopify.processCartQueue();
    $('button, input').prop('disabled', true);
    $('#AddBundleToCart').addClass('btn--loading');
  }
  
  function removeCartItem(product) {
    var thisId = product.attr('data-variant');
    addToQueue('change',thisId,0,{});    
    Shopify.processCartQueue();
  } 

/*============================================================================
      #PRODUCT
  ==============================================================================*/  
    

  document.querySelectorAll('vimeo-embed, youtube-embed').forEach(v => {
    const [poster, src] = v.tagName === 'VIMEO-EMBED' ?
      [`vumbnail.com/${v.id}.jpg`, 'player.vimeo.com/video'] :
      [`i.ytimg.com/vi/${v.id}/hqdefault.jpg`, 'www.youtube.com/embed'];
  
    v.innerHTML = `<img loading="lazy" src="" id="vimeo-${v.id}" alt="${v.title}"><button aria-label="Play"></button>`;
    v.children[1].addEventListener('click', () => v.innerHTML = `<iframe allow="autoplay; fullscreen" loading="lazy" src="https://${src}/${v.id}?autoplay=1" frameborder="0"></iframe>`)
    vimeoLoadingThumb(`${v.id}`);
  });
  
  var reviewsWait = setInterval(function() {
    if($('.box_grid__item .jdgm-prev-badge__text')){
      $('.box_grid__item .jdgm-prev-badge__text').each(function(){
        var html = $(this).html();
        html = html.replace(' reviews','');
        html = '('+html+')';
        $(this).html(html);
      }) ;      
      clearInterval(reviewsWait);
    }
  }, 100);
  
  if(getParameterByName('review')) {
    var wait = setInterval(function() {
      if($('body').find('.jdgm-write-rev-link').length > 0) {
        $(document).scrollTop( $("#write-a-review").offset().top );  
        $('body').find('.jdgm-form-wrapper').slideDown();
        clearInterval(wait);
      }
    }, 100);     
  }
  
  if(getParameterByName('option')) {
    var wait = setInterval(function() {
      if($('body').find('.variant-buttons').length > 0) {
        $(document).find('#variant_2').trigger('click');
        clearInterval(wait);
      }
    }, 100);
  }
   
  if($('#quantity')) {
    var _href = $('.bundle-selector .btn').attr('href');
    $('#quantity').change(function(){
      $('.bundle-selector .btn').attr('href', _href + '&qty=' + this.value);
    });
  }
  
  $('.variant-buttons div').on('click', function() {
    var variants = $(this).attr('data-variants'),
        image_number = $(this).attr('data-image-number');
    
    if(image_number == 1) {
      $('.starting-slide').show();
      $('.secondary-slide').hide();
    } else {
      $('.starting-slide').hide();
      $('.secondary-slide').show();
    }
    
    $('#AddBundleToCart').attr('data-variants', variants);
    $('.variant-buttons div').removeClass('selected');
    $(this).addClass('selected');
  });

/*============================================================================
      #CART UPDATE SCRIPTS
  ==============================================================================*/    


  if($('.template-product').length > 0) {
    $(document).on('click', '.product-options .btn-add:not(.btn-quick-add), .product-options .js-qty__adjust--plus', function(e){
      e.preventDefault();
      cartUpdate('add','product',null);
    });
    $(document).on('click', '.bundle-options .btn-add, .bundle-options .js-qty__adjust--plus', function(e){
      e.preventDefault();
      cartUpdate('add','product-bundle',null);
    });
    $(document).on('click', '.js-qty__adjust--minus', function(e){
      e.preventDefault();
      cartUpdate('remove','product',null);
    });
  }  

  if($('.template-collection .grid-product').length > 0) {
    $(document).on('click', '.box_grid__item .btn-add, .non-bundle .btn-add' , function(e){
      e.preventDefault();
      cartUpdate('add','collection',$(this));
    });
    $(document).on('click', '.box_grid__item .js-qty__adjust--plus, .non-bundle .js-qty__adjust--plus', function(e){
      e.preventDefault();
      cartUpdate('add','collection-qty',$(this));
    });    
    $(document).on('click', '.box_grid__item .js-qty__adjust--minus, .non-bundle .js-qty__adjust--minus', function(e){
      e.preventDefault();
      cartUpdate('remove','collection-qty',$(this));
    });
    $(document).on('click', '.bundle-entree .btn-add', function(e){
      e.preventDefault();
      cartUpdate('add','collection-bundle',$(this));
    });    
    $(document).on('click', '.bundle-entree .js-qty__adjust--plus', function(e){
      e.preventDefault();
      cartUpdate('add','collection-bundle-qty',$(this));
    });       
    $(document).on('click', '.bundle-entree .js-qty__adjust--minus', function(e){
      e.preventDefault();
      cartUpdate('remove','collection-bundle-qty',$(this));
    }); 
  }
  
  if($('.template-cart .cart__row--table').length > 0) {
    $(document).on('click', '.ajaxcart__quantity .js-qty__adjust--minus', function(e){
      e.preventDefault();
      cartUpdate('remove','cart-qty',$(this));
    });
    $(document).on('click', '.ajaxcart__quantity .js-qty__adjust--plus', function(e){
      e.preventDefault();
      cartUpdate('add','cart-qty',$(this));
    });    
  }

  $(document).on('click', '.entree-bundle-add-to-cart', function(e){
    e.preventDefault();
    addBundleToCart($(this));
  });
  
  function cartUpdate(action,type,button){
    var removeList = '',
        customUpdateList = '',
        addList = '',
        savingsMessage = '',
        promoMessage = '',
        bundleSize = 8;
    
    if(type =='product' || type == 'product-bundle'){
      var thisButton = $('.btn-add'),
          thisQtyField = $('.js-qty__num'),
          wrapper = $('.product__quick-options'),
          nonBundleCount = Number($('.product-section').attr('data-non-bundle-qty')),
          thisSubTotal = Number($('.product-section').attr('data-cart-subtotal'));
    }
    if(type =='collection'){
      var thisButton = button,
          thisQtyField = button.parent().find('.js-qty__num'),
          wrapper = button.closest('.grid-product');
    }
    if(type =='collection-qty'){
      var thisButton = button.closest('.grid_product__quick-options').find('.btn-add'),
          thisQtyField = button.parent().find('.js-qty__num'),
          wrapper = button.closest('.grid-product');
    }
    if(type =='collection-bundle'){
      var thisButton = button,
          thisQtyField = button.parent().find('.js-qty__num'),
          wrapper = button.closest('.grid-product');
    }
    if(type =='collection-bundle-qty'){
      var thisButton = button.closest('.grid_product__quick-options').find('.btn-add'),
          thisQtyField = button.parent().find('.js-qty__num'),
          wrapper = button.closest('.grid-product');
    }
    if(type.includes('collection')){
      var customIsFirst = $('#CollectionSection').attr('data-custom-first'),
          nonBundleCount = Number($('#CollectionSection').attr('data-non-bundle-qty')),
          thisSubTotal = Number($('#CollectionSection').attr('data-cart-subtotal'));
    }
    if(type =='cart-qty'){
      var thisButton = button.parent().find('.js-qty__num'),
          thisQtyField = button.parent().find('.js-qty__num'),
          thisPrice = Number(thisButton.attr('data-price')),
          wrapper = button.closest('.cart__product'),
          nonBundleCount = Number($('.full_cart').attr('data-non-bundle-qty')),
          thisLineTotal = wrapper.find('.cart__line-total'),
          thisSubTotalField = $('.cart__subtotal'),
          thisSubTotal = Number(thisSubTotalField.html().replace('Subtotal: $',''));
    }
      
    var thisType = thisButton.attr('data-type');

    if(thisType == 'bundle') {
      var thisVariants = thisButton.attr('data-variants'),
          thisVariantQtys = thisButton.attr('data-qtys'),
          thisTitle = thisButton.attr('data-title'),
          thisKeys = thisButton.attr('data-keys'),
          thisProductCount = thisButton.attr('data-product-count');
      
      thisVariants = thisVariants.split(',');
      thisKeys = thisKeys.split(',');
      thisVariantQtys = thisVariantQtys.split(',');
      thisBundleSize = 0;
      for(const thisVariantQty of thisVariantQtys) {
        thisBundleSize += Number(thisVariantQty);
      }
    } else {
      var thisVariant = thisButton.attr('data-variant'),
          thisKey = thisButton.attr('data-key');
    }
   
    var thisImage = thisButton.attr('data-image'),
        thisTitle = thisButton.attr('data-title'),
        thisColor = thisButton.attr('data-color'),
        thisQty = Number(thisQtyField.val()),
        thisCartBubble = $(document).find('.cart-link__bubble'),
        thisTotalQty = Number(thisCartBubble.html()),
        thisPrice = Number(thisButton.attr('data-price'));
   
    if(action == 'remove') {
      thisQty-=1;
      thisQtyField.val(thisQty);
      thisSubTotal -= thisPrice;
      
      if(thisType == 'bundle') {
        thisTotalQty-=thisBundleSize;
        for(var i=0; i<thisProductCount; i++) {
          if(removeList.length > 0){ removeList += '&' }
          removeList += 'updates[' + thisKeys[i] + ']=0';
        }
        addToQueue('update',removeList,null,null);
      } else {
        thisTotalQty-=1;
        if(thisQty < 0) {
          thisQty == 0;
          thisLine = "";
        }
        addToQueue('update','updates[' + thisKey + ']=' + thisQty,null,null);
        if(thisType != 'heat-eat-entree' && thisType != 'pasta'){
          nonBundleCount-=1;
          $('.product-section').attr('data-non-bundle-qty',nonBundleCount);  
          $('#CollectionSection').attr('data-non-bundle-qty',nonBundleCount); 
          $('.full_cart').attr('data-non-bundle-qty',nonBundleCount);
        }
      }      
      actionMessage = 'Removed from Cart';
    } else {
      // if action = add
      thisQty+=1;
      thisQtyField.val(thisQty);
      thisSubTotal += thisPrice;
      
      thisTotalQty+=1;
      if(thisQty == 1) {
        addToQueue('add',thisVariant,1,false,thisButton);
      }
      if(thisQty > 1) {
        addToQueue('update','updates[' + thisKey + ']=' + thisQty,null,null);
      }
      //Update non bundle counts if heat eat entree
      if(thisType != 'heat-eat-entree' && thisType != 'pasta'){
        nonBundleCount+=1;
        $('.product-section').attr('data-non-bundle-qty',nonBundleCount);
        $('#CollectionSection').attr('data-non-bundle-qty',nonBundleCount);
        $('.full_cart').attr('data-non-bundle-qty',nonBundleCount);
      }
      actionMessage = 'Added to Cart';
    }

    bundleQty = thisTotalQty - nonBundleCount;
    
    remainder = 6 - bundleQty;
    if(remainder < 0) { remainder = 0; }
    
    if(type.includes('collection') || type.includes('product')) {
      
      if(action == 'add') { wrapper.addClass('selected'); }
      if(thisQty == 0) { wrapper.removeClass('selected'); }
      
      if(type.includes('collection')){
        $('#CollectionSection').attr('data-cart-subtotal',parseFloat(thisSubTotal).toFixed(2));
      }
      if(type.includes('product')){
        $('.product-section').attr('data-cart-subtotal',parseFloat(thisSubTotal).toFixed(2));
      }

      savingsMessage = '';
      if(remainder == 0 || nonBundleCount > 0) {
        $('.cart-message__checkout-message').show();
      } else {
        $('.cart-message__checkout-message').hide();
      }
      $('.card-btn').show();
      $('.cart-message__wrapper').finish().css('height','0').animate({height: '175px'}, 500).delay(5000).animate({height: '0'}, 500);
      $('.cart-message__color-bar').css('background', thisColor);
      $('.cart-message__image').attr('src',thisImage);
      $('.cart-message__product-message').html(thisTitle);
      $('.cart-message__product-action-message').html(actionMessage);
    } else {
      thisLineTotal.html('$'+ parseFloat(thisQty * thisPrice).toFixed(2));
      thisSubTotalField.html('Subtotal: $' + parseFloat(thisSubTotal).toFixed(2));
      
      var shipping_bug = (thisSubTotal < 50) ? '+ Shipping & Taxes (where applicable)' : '+ <strong>FREE</strong> Shipping & Taxes (where applicable)'
      $('.tax-shipping-bug').html(shipping_bug);

      if(thisSubTotal < 50) {
        if(bundleQty > 0 && remainder != 0) {
        } else {
          $('.shipping-notice').show()
          $('.shipping').html('Add $' + parseFloat(120 - thisSubTotal).toFixed(2) + ' More For Free Shipping');
        }
      } else {
        $('.shipping-notice').hide();
      }  
      
      if(thisQty == 0) { wrapper.remove(); }
      if(thisTotalQty == 0) {
        $('.cart').hide();
        $('#empty_cart').show();
      }
    }
  
    var note = '',
      bq = bundleQty;
    
    Shopify.processQueue();
    
    if(thisTotalQty > 0) {
      thisCartBubble.addClass('cart-link__bubble--visible').addClass('size-pulse').html(thisTotalQty);
      setTimeout(function() {
        thisCartBubble.removeClass('size-pulse');
      }, 200);
    } else {
      thisCartBubble.removeClass('cart-link__bubble--visible').html(thisTotalQty);
    }
    if(type =='cart-qty'){
      $('#item_count').html(thisTotalQty);
    }
  }
  
  function addBundleToCart(product) {
    var variants = product.attr('data-variants'),
      qtys = product.attr('data-qtys'),
      title = product.attr('data-title'),
      addList = '';

    variants = variants.split(',');
    qtys = qtys.split(',');

    for(var i=0; i<variants.length; i++) {
      var id = variants[i];
          qty = Number(qtys[i]);
      
      if(addList.length == 0){ addList += '{ "items": [' } else { addList += ',' }
      addList += '{ "quantity": ' + qty + ', "id": ' + id + '}';
    }
    addList += ']}';
    addToQueue('addMany',JSON.parse(addList),null,null);
    
    Shopify.processQueueThenGoToCart();
  }  



  
    
 /*============================================================================
      #COLLECTION
  ==============================================================================*/

  // ===== Scroll to Top ==== 
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {
      $('#return-to-top').fadeIn(200);
    } else {
      $('#return-to-top').fadeOut(200);
    }
  });
  $('#return-to-top').click(function() {
    $('body,html').animate({ scrollTop : 0 }, 500);
  });

  $('.collection-icons a, .subnav a').on('click', function(e){
    e.preventDefault();
    var anchor = $("h2[id='"+ $(this).attr('href').replace('#','') +"']");
    $('html,body').animate({scrollTop: (anchor.offset().top - 110) },'slow');
  });
  
  if(getParameterByName('pre-select')) {
    var preselectWait = setInterval(function() {
      if($('body').find('.grid__item').length > 0) {
        $('.grid_product__quick-options').removeClass('hide');
        $(document).find('.grid__item[data-product-id=' + getParameterByName('pre-select') + '] .quick-add-to-cart').trigger('click');
        clearInterval(preselectWait);
      }
    }, 100);
  }

  if(getParameterByName('pre-select-entree')) {
    var productID = getParameterByName('pre-select-entree');
    var preselectEntreeWait = setInterval(function() {
      var productGridItem = $(document).find('#grid-product-' + productID + ' .btn-add');
      if(productGridItem.length > 0) {
        productGridItem.trigger('click');
        clearInterval(preselectEntreeWait);
        window.history.replaceState({}, document.title, "/collections/shop");
      }
    }, 100);
  }
  
  if( /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    if($('.template-collection .grid-product')) {
      $(document).find('.quick-product__btn').css('opacity','1').css('top','16%');
      $(document).find('.flickity-button').css('width','20px !important');
    }
  }
  // Added to support Filter Dropdown //
  $('#SortTags').on('change', function() {
    location.href = $(this).val();
  });

  
  /*============================================================================
      #SHOPIFY
  ==============================================================================*/ 
  
  Shopify.queue = [];
                
  // Function for processing a queue of cart actions to perform.
  Shopify.processCartQueue = function() {   
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      if(request.type == 'add') {
        Shopify.addItemToCart(request.variantId, request.quantity, request.properties, Shopify.processCartQueue);
      }
      if(request.type == 'addMany') {
        Shopify.addItems(request.variantId, Shopify.processCartQueue);
      }      
      if(request.type == 'change') {
        Shopify.changeItem(request.variantId, request.quantity, Shopify.processCartQueue);
      }
      if(request.type == 'update') {
        Shopify.updateItems(request.variantId, Shopify.processCartQueue);
      }  
    } else {
      window.location.href = "https://www.kevinsnaturalfoods.com/cart";
    }
  };
  
  Shopify.processQueue = function() {
    $('button:not(.flickity-button), input').prop('disabled', true);
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      if(request.type == 'add') {
        Shopify.addItemToCart(request.variantId, request.quantity, request.properties, Shopify.processQueue, request.block);
      }
      if(request.type == 'addMany') {
        Shopify.addItems(request.variantId, Shopify.processQueue,request.block);
      }      
      if(request.type == 'change') {
        Shopify.changeItem(request.variantId, request.quantity, Shopify.processQueue);
      }
      if(request.type == 'update') {
        Shopify.updateItems(request.variantId, Shopify.processQueue);
      }        
      if(request.type == 'note') {
        Shopify.addAttributes(request.properties, Shopify.processQueue);
      }
    } else {
      $('button, input').prop('disabled', false);
      $('.js-qty__num').prop('disabled', true);
      $('.js-qty-product__num').prop('disabled', true);
    }
  };
  
  Shopify.processQueueThenGoToCart = function() {
    $('button:not(.flickity-button), input').prop('disabled', true);
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      if(request.type == 'add') {
        LO.events.track('Added To Cart')
        Shopify.addItemToCart(request.variantId, request.quantity, request.properties, Shopify.processQueueThenGoToCart);
      }
      if(request.type == 'addMany') {
        Shopify.addItems(request.variantId, Shopify.processQueueThenGoToCart);
      }      
      if(request.type == 'change') {
        Shopify.changeItem(request.variantId, request.quantity, Shopify.processQueueThenGoToCart);
      }
      if(request.type == 'changeProperties') {
        Shopify.changeItem(request.variantId, request.quantity, request.properties, Shopify.processQueueThenGoToCart);
      }
      if(request.type == 'update') {
        Shopify.updateItems(request.variantId, Shopify.processQueueThenGoToCart);
      }      
    } else { 
      window.location.href = "https://www.kevinsnaturalfoods.com/cart";
    }
  };
    
  // Change the quantity of an item
  Shopify.addAttributes = function(note, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: note,
      success: function(){    
        if(typeof callback === 'function'){
          callback();
        }
      },
      error: function(){}
    });
  }
  
  Shopify.changeItem = function(id, qty, callback) {
    var params = { quantity: qty, id: id };
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: params,
      success: function(){
        if(typeof callback === 'function'){
          callback();
        }
      },
      error: function(){}
    });
  }
  
  // Change the quantity of an item        
  Shopify.updateItems = function(list, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: list,
      success: function(){
        if(typeof callback === 'function'){
          callback();
        }
      },
      error: function(){}
    });
  }
  
  
  // Add a new item to the cart.
  Shopify.addItemToCart = function(id, qty, props, callback, block) {   
    var params = { quantity: qty, id: id };
    if(props != false){
      params.properties = props;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: params,
      success: function(response){
        _learnq.push(['track', 'Added to Cart', response.item]);
        if(typeof callback === 'function'){
          key = response.key;
          block.attr('data-key', key);         
          callback();
        }
      },
      error: function(){
        console.log('there was an error');
      }
    });
  }
  
  // Add multiple items to the cart.
  Shopify.addItems = function(items, callback, block) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: items,
      success: function(response){
        _learnq.push(['track', 'Added to Cart', response.items]);
        if(typeof callback === 'function'){         
          var keys = '';
          if(block != null){
            if(block.hasClass('btn-custom')){
              for(var i=0; i<response.items.length; i++) {
                key = response.items[i].key;
                if(keys.length >0){ keys+=',' }
                keys += key;
              }
              if(block.length > 1) {
                var theKeys = keys.split(',')
                block.each(function(index){
                  $(this).attr('data-key',theKeys[index]);
                });
              } else {
                block.attr('data-key', keys);
              }
            } else {
              for(var i=0; i<response.items.length; i++) {
                key = response.items[i].key;
                if(keys.length >0){ keys+=',' }
                keys += key;
              }
              block.attr('data-keys', keys);
            }
          }
          callback();
        }
      },
      error: function(){}
    });
  }    
  
  // Add a cart action to the queue
  function addToQueue(type, id, qty, props, block) {
    Shopify.queue.push({
      type: type,
      variantId: id,
      quantity: qty,
      properties: props,
      block: block
    });
  }
  
    
   /*============================================================================
      #RECIPES
  ==============================================================================*/

  var ctrlVideo = document.getElementById("insta-video");
  $('.video-play').click(function(){
    if ($('.video-play').hasClass("active")){
        ctrlVideo.play();
        ctrlVideo.setAttribute("controls","controls")    
      $('.video-play').html("Pause");
      $('.video-play').removeClass("active");
    }
  });
   
  if($('.recipe-filters')) {
    $('.recipe-filters select').change(function(){
      window.location.href = this.value;
    });
  }
  
   /*============================================================================
      #BRC LANDING
  ==============================================================================*/
  
  if($('#expand-rules')) {
    $(document).on('click', '#expand-rules', function(){
      $('.brc-rules-expand').slideDown();
    });
    
    if(window.location.hash == '#brc-rules') {
      $('.brc-rules-expand').slideDown();
    }
  } 
    
});

function getDirections(daddr) {
  saddr = document.getElementById("position").value;
  window.open('http://maps.google.com/maps?saddr=' + encodeURI(saddr) + '&daddr=' + encodeURI(daddr))
}


function getToday() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  return yyyy + '-' + mm + '-' + dd;
}

function getPanBy(zoom) {
  if($(window).width() > 1000) {
    return (($(window).width() / zoom)*-1)		
  } else {
    return 50;
  }	
}

function delimit(txt,del) {
  if(txt.length > 0) { return (del + ' ') } else { return '' }
}

var rad = function(x) {
  return x * Math.PI / 180;
};

var getDistance = function(lat1, lon1, lat2, lon2 ) {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(lat2 - lat1);
  var dLong = rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  d = d * 0.0006213712; // converts to miles
  d = d + d*0.43;
  return d; // returns the distance in miles
};
  
  
function openCart() {
  $('.js-drawer-open-cart').trigger('click');
  var URL = window.location.href.replace('&cart=open','').replace('?cart=open','?'),
      pageTitle = document.title;
      
  window.history.replaceState('/',pageTitle, URL);
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function isElementInViewport (el) {
  // Special bonus for those using jQuery
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

function onVisibilityChange(el, callback) {
  var old_visible;
  return function () {
    var visible = isElementInViewport(el);
    if (visible != old_visible) {
      old_visible = visible;
      if (typeof callback == 'function') {
        callback();
      }
    }
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function eraseCookie(cname) {
  setCookie(cname,"",-1);
}

function vimeoLoadingThumb(id){    
  var url = "http://vimeo.com/api/v2/video/" + id + ".json?callback=showThumb";
  var id_img = "#vimeo-" + id;
  var script = document.createElement( 'script' );
  script.src = url;
  $(id_img).before(script);
}

function showThumb(data){
  var id_img = "#vimeo-" + data[0].id,
  thumbURL = data[0].thumbnail_medium;
  thumbURL = thumbURL.replace('200x150','550x550');
  $(id_img).attr('src',thumbURL);
}